__turbopack_context__.v({
  "card": "UniversalCard-module-scss-module__b0lDdG__card",
  "content": "UniversalCard-module-scss-module__b0lDdG__content",
  "ctas": "UniversalCard-module-scss-module__b0lDdG__ctas",
  "ctasRows": "UniversalCard-module-scss-module__b0lDdG__ctasRows",
  "hAlign-center": "UniversalCard-module-scss-module__b0lDdG__hAlign-center",
  "hAlign-right": "UniversalCard-module-scss-module__b0lDdG__hAlign-right",
  "heading": "UniversalCard-module-scss-module__b0lDdG__heading",
  "hideDesktop": "UniversalCard-module-scss-module__b0lDdG__hideDesktop",
  "hideMobile": "UniversalCard-module-scss-module__b0lDdG__hideMobile",
  "mb-1": "UniversalCard-module-scss-module__b0lDdG__mb-1",
  "mb-2": "UniversalCard-module-scss-module__b0lDdG__mb-2",
  "mb-3": "UniversalCard-module-scss-module__b0lDdG__mb-3",
  "mb-4": "UniversalCard-module-scss-module__b0lDdG__mb-4",
  "mb-none": "UniversalCard-module-scss-module__b0lDdG__mb-none",
  "media": "UniversalCard-module-scss-module__b0lDdG__media",
  "plr-1": "UniversalCard-module-scss-module__b0lDdG__plr-1",
  "plr-2": "UniversalCard-module-scss-module__b0lDdG__plr-2",
  "plr-3": "UniversalCard-module-scss-module__b0lDdG__plr-3",
  "plr-4": "UniversalCard-module-scss-module__b0lDdG__plr-4",
  "plr-none": "UniversalCard-module-scss-module__b0lDdG__plr-none",
  "ptb-1": "UniversalCard-module-scss-module__b0lDdG__ptb-1",
  "ptb-2": "UniversalCard-module-scss-module__b0lDdG__ptb-2",
  "ptb-3": "UniversalCard-module-scss-module__b0lDdG__ptb-3",
  "ptb-4": "UniversalCard-module-scss-module__b0lDdG__ptb-4",
  "ptb-none": "UniversalCard-module-scss-module__b0lDdG__ptb-none",
  "subtitleBottom": "UniversalCard-module-scss-module__b0lDdG__subtitleBottom",
  "subtitleTop": "UniversalCard-module-scss-module__b0lDdG__subtitleTop",
  "text": "UniversalCard-module-scss-module__b0lDdG__text",
  "textAlign-center": "UniversalCard-module-scss-module__b0lDdG__textAlign-center",
  "textAlign-justify": "UniversalCard-module-scss-module__b0lDdG__textAlign-justify",
  "textAlign-left": "UniversalCard-module-scss-module__b0lDdG__textAlign-left",
  "textAlign-right": "UniversalCard-module-scss-module__b0lDdG__textAlign-right",
  "textSize-compact": "UniversalCard-module-scss-module__b0lDdG__textSize-compact",
  "textSize-extra-large": "UniversalCard-module-scss-module__b0lDdG__textSize-extra-large",
  "textSize-large": "UniversalCard-module-scss-module__b0lDdG__textSize-large",
  "textSize-small": "UniversalCard-module-scss-module__b0lDdG__textSize-small",
  "textWidth-large": "UniversalCard-module-scss-module__b0lDdG__textWidth-large",
  "textWidth-medium": "UniversalCard-module-scss-module__b0lDdG__textWidth-medium",
  "type-MediaBackground": "UniversalCard-module-scss-module__b0lDdG__type-MediaBackground",
  "type-MediaBottom": "UniversalCard-module-scss-module__b0lDdG__type-MediaBottom",
  "type-MediaLeft": "UniversalCard-module-scss-module__b0lDdG__type-MediaLeft",
  "type-MediaRight": "UniversalCard-module-scss-module__b0lDdG__type-MediaRight",
  "type-MediaTop": "UniversalCard-module-scss-module__b0lDdG__type-MediaTop",
  "type-Text": "UniversalCard-module-scss-module__b0lDdG__type-Text",
  "vAlign-bottom": "UniversalCard-module-scss-module__b0lDdG__vAlign-bottom",
  "vAlign-center": "UniversalCard-module-scss-module__b0lDdG__vAlign-center",
});
